/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Quarter_RunningInputs */



/**
* | output |
* | --- |
* | "Quarter still running — payout after quarter end." |
*
* @param {Partner_Admin_Commission_Quarter_RunningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_quarter_running = /** @type {((inputs?: Partner_Admin_Commission_Quarter_RunningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Quarter_RunningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Quartal läuft noch — Auszahlung nach Quartalsende.")
	return /** @type {LocalizedString} */ ("Quarter still running — payout after quarter end.")
});